import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './junior-pilot.actions';
import { JuniorPilotState } from './junior-pilot.state';

/**
 * juniorPilot initial state
 */
export const juniorPilotInitialState: JuniorPilotState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for JuniorPilot Store
 */
export const juniorPilotReducerFeatures: ReducerTypes<JuniorPilotState, ActionCreator[]>[] = [
  on(actions.setJuniorPilot, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateJuniorPilot, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetJuniorPilot, () => juniorPilotInitialState),

  on(actions.cancelJuniorPilotRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failJuniorPilot, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setJuniorPilotFromApi, actions.updateJuniorPilotFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * JuniorPilot Store reducer
 */
export const juniorPilotReducer = createReducer(juniorPilotInitialState, ...juniorPilotReducerFeatures);
